// libraries
import React from 'react'
import clsx from 'clsx'

// icons
import { Download } from '/react4xp/components/Svg/Ux/Ux'
import { PadLock } from '/react4xp/components/Svg/Others/Icons'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface MacroDownloadListProps {
	theme: 'beige' | 'green' | 'blue'
	heading?: string
	downloadList: Array<{
		name: string
		size: string
		fileLink: string
		isRestricted?: boolean
	}>
}

export default function MacroDownloadList({
	theme,
	heading,
	downloadList
}: MacroDownloadListProps) {
	return (
		<div className={clsx(
			'macro__download-list',
			theme === 'beige' && 'macro__download-list--beige',
			theme === 'green' && 'macro__download-list--green',
			theme === 'blue' && 'macro__download-list--blue'
		)}>

			{isNonWhitespaceString(heading) && (
				<h3 className='title-xs download-list-heading'>
					{heading}
				</h3>
			)}

			{downloadList && (
				<div className='download-list-items'>
					
					<div className='download-list-items__heading'>
						
						<p className='name'>
							Name
						</p>

						<p className='size'>
							Size
						</p>

						<p className='download'>
							Download
						</p>

					</div>

					<div className='download-list-items__content'>
						{downloadList.map((item, i) => (
							<a
								key={i}
								href={item.fileLink}
								download={!item.isRestricted}
								className='download-list-items__item'
							>

								<span className='name'>
									{item.name}
								</span>

								<span className='size'>
									{item.size ? item.size : '--'}
								</span>

								<span className='download'>
									{item.isRestricted ? (
										<PadLock />
									) : (
										<Download />
									)}
								</span>

							</a>
						))}
					</div>

				</div>
			)}

		</div>
	)
}